<template>
	<section class="d-flex justify-content-between mb-2 filter-content">
		<div class="p-2 flex-shrink-1">
            <button class="btn btn-sm btn-primary" @click="modal_open">Filtros</button>
        </div>
        
        <div class="p-2 w-100 d-flex justify-content-between">
            <input class="form-control form-control-sm" type="text" placeholder="Pressione a tecla enter para procurar na lista.." v-model="search" v-on:keyup="search_list">
            <button class="btn btn-sm btn-info ml-2" @click="clear">Limpar</button>
        </div>

		<Modal :filter_data="filter_data" @set_filter="set_filter" />
	</section>
</template>

<script>
    import Modal   from "@/components/Modal/Filter.vue"

	export default {
		name: "Filtros",
		props: ['filter_data'],
        components: { Modal },

		data() { 
			return {
				filter: null,
				operador: null,
				search: ""
			}
		},

		methods: {
			modal_open() {
				$("#modal-filter").modal();
			},

			clear() {
				this.search = '';
				this.$emit('filtrar', "");
			},

			set_filter(payload) {
				this.$emit('filtrar', payload);
			},

			search_list: function(e) {
				if(e.keyCode === 13){
					const value = this.search;
					const filter = `&like=1&value=${value}`;
					this.$emit('filtrar', filter);
					console.log(value);
				}
			},
		}
	}
</script>

<style>
	.filter-content { 
		border: 2px solid #147F75; 
		-moz-border-radius: 8px; 
		-webkit-border-radius: 8px;
		border-radius: 8px; 
		background-color: rgba(220, 220, 220, 0.7);
		margin-bottom: 10px
	}
</style>